// src/pages/support/UniqueWaysToGive.js
import React from "react";
import { Helmet } from "react-helmet";
import dummyImage from "../../assets/images/support/unique.webp";
import CTASection from "../../components/CTASection"; // Add CTASection import
import styled from "styled-components"; // Add styled-components
import SupportOpportunity from "../../components/SupportOpportunity";

const UniqueWaysToGive = () => {
  const description = `
    Discover unique ways to support Habitat for Humanity Buffalo. From donating your car to creating a fundraising event, there are many ways you can help build homes and hope.
  `;

  const waysToSupport = [
    "Donate your car",
    "Host a fundraising event",
    "Shop at our ReStore",
  ];

  return (
    <>
      <Helmet>
        <title>Unique Ways to Give - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Discover unique ways to support Habitat Buffalo. Donate your car, host a fundraiser, or shop at our ReStore to help build homes and hope."
        />
      </Helmet>
      <Container>
        <SupportOpportunity
          title="Unique Ways to Give"
          image={dummyImage}
          description={description}
          waysToSupport={waysToSupport}
        />
        {/* Add CTA Section */}
        <CTASection
          title="Explore Unique Ways to Give"
          description="Ready to explore unique ways to support Habitat Buffalo? Click the button below to get started."
          buttonText="Get Started"
          buttonLink="/form/giving"
        />
      </Container>
    </>
  );
};

// Add necessary styled components
const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

export default UniqueWaysToGive;
